/**
 * Scrolltrigger Scroll Check
 */
function initScrolltriggerNav() {
  console.log("YEAH");
  ScrollTrigger.create({
    start: "top -30%",
    // markers: true,
    onUpdate: (self) => {
      $("main").addClass("scrolled");
    },
    onLeaveBack: () => {
      $("main").removeClass("scrolled");
    },
  });
}

function initScript() {
  initScrolltriggerNav();
}
initScript();
